import { ItemsByCountry, ListItemBase } from './types';

export const itemsByCountry = <T extends ListItemBase>(items: T[]) => {
  const sortedItems = items.sort((a, b) => {
    const aName = a.name.toLowerCase();
    const bName = b.name.toLowerCase();

    if (a.countryCode > b.countryCode) return 1;
    if (a.countryCode < b.countryCode) return -1;
    if (aName > bName) return 1;
    if (aName < bName) return -1;
    return 0;
  });

  return sortedItems.reduce((acc, item, index) => {
    if (index === 0 || sortedItems[index - 1].countryCode !== item.countryCode) {
      return [...acc, { countryCode: item.countryCode, items: [item] }];
    }
    const head = acc.slice(0, -1);
    const lastItem = acc.slice(-1)[0];
    return [...head, { countryCode: lastItem.countryCode, items: [...lastItem.items, item] }];
  }, [] as ItemsByCountry<T>);
};

export const getAllCountryCodesForItems = <T extends ListItemBase>(items: T[]) =>
  items.reduce(
    (acc, { countryCode }) => (acc.includes(countryCode) ? acc : [...acc, countryCode]),
    [] as string[],
  );

export const uniqueCodesFromItems = <T extends { code: string }>(codes: string[], items: T[]) =>
  items.reduce((acc, { code }) => (codes.includes(code) ? acc : [...acc, code]), codes);

export const getCountriesBySelectedItems = <T extends ListItemBase>(
  filterItems: string[],
  items: T[],
) =>
  items.reduce(
    (acc, { code, countryCode }) =>
      filterItems.includes(code) && !acc.includes(countryCode) ? [...acc, countryCode] : acc,
    [] as string[],
  );
